.stepper {
    display: flex;
    align-items: flex-start;
    gap: var(--tempest-space-2);
    width: 100%;
    font-family: var(--tempest-font-sans);
}

.stepper.vertical {
    flex-direction: column;
    align-items: stretch;
}

.step {
    display: flex;
    align-items: center;
    gap: var(--tempest-space-2);
    flex: 1;
}

.dot {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 2px solid var(--tempest-border-strong);
    background-color: var(--tempest-bg);
    color: var(--tempest-text-muted);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--tempest-text-xs);
    font-weight: var(--tempest-weight-bold);
    flex-shrink: 0;
    transition: var(--tempest-transition-color);
}

.step.completed .dot {
    background-color: var(--tempest-primary);
    border-color: var(--tempest-primary);
    color: var(--tempest-primary-foreground);
}

.step.active .dot {
    border-color: var(--tempest-primary-on-soft);
    color: var(--tempest-primary-on-soft);
    box-shadow: 0 0 0 4px var(--tempest-primary-soft);
}

.label {
    font-size: var(--tempest-text-sm);
    color: var(--tempest-text-muted);
    font-weight: var(--tempest-weight-semibold);
    line-height: var(--tempest-leading-snug);
}

.step.active .label,
.step.completed .label {
    color: var(--tempest-text);
}

.connector {
    flex: 1;
    height: 2px;
    background-color: var(--tempest-border);
    margin: 0 var(--tempest-space-1);
    transition: background-color var(--tempest-duration-base) var(--tempest-ease-out);
}

.connector.completed {
    background-color: var(--tempest-primary);
}

.stepper.vertical .connector {
    width: 2px;
    height: 24px;
    margin: 0 0 0 13px;
}

/* Mobile — horizontal stepper becomes vertical automatically. */
@media (max-width: 639.98px) {
    .stepper:not(.vertical) {
        flex-direction: column;
        align-items: stretch;
    }
    .stepper:not(.vertical) .connector {
        width: 2px;
        height: 16px;
        margin: 0 0 0 13px;
    }
}

.labelGroup {
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-1);
    min-width: 0;
}

.description {
    font-size: var(--tempest-text-xs);
    color: var(--tempest-text-subtle);
}

.trigger {
    display: flex;
    align-items: center;
    gap: var(--tempest-space-2);
    padding: 0;
    background: none;
    border: 0;
    font: inherit;
    color: inherit;
    cursor: pointer;
    border-radius: var(--tempest-radius-sm);
}

.trigger:focus-visible {
    outline: var(--tempest-focus-ring-width) solid var(--tempest-focus-ring-color);
    outline-offset: var(--tempest-focus-ring-offset);
}
